import React from 'react';
import Survey, { CssNames } from '../../../Survey';
import DemographicsSurvey, { TestIntro } from './demographics';
import DemographicsWrapper from './demographics.styles';
import showdown from 'showdown';

class Habilidades extends React.Component {
  state = {
    intro: true
  };
  onCompleteIntro = () => {
    this.setState({ intro: false });
  };

  onComplete = async (survey, options) => {
    const { onComplete } = this.props;

    const { data } = survey;
    const parsed = {
      ...data
    };
    await onComplete(parsed);
  };

  render() {
    const { intro } = this.state;
    const IntroModel = new Survey.Model(TestIntro);
    const DemographicsModel = new Survey.Model(DemographicsSurvey);
    // setting starting data
    DemographicsModel.data = this.props.initialData || {};
    //Create showdown mardown converter
    var converter = new showdown.Converter();
    DemographicsModel.onTextMarkdown.add((survey, options) => {
      //convert the mardown text to html
      var str = converter.makeHtml(options.text);
      // console.log({ str });
      str = str.substring(3, str.length - 4); // remove first 3 and last 4 characters (<p> and closing </p>)
      // console.log({ result: str });
      //set html
      options.html = str;
    });

    return (
      <DemographicsWrapper>
        <div className='edu_header'></div>
        {intro && (
          <Survey.Survey
            model={IntroModel}
            css={CssNames}
            onComplete={this.onCompleteIntro}
          />
        )}
        {!intro && (
          <Survey.Survey
            model={DemographicsModel}
            css={CssNames}
            onComplete={this.onComplete}
          />
        )}

        <div className='Plug'>
          <a
            href='http://www.edumetrics.cl/'
            target='_blank'
            rel='noopener noreferrer'
          >
            EduMetrics
          </a>
        </div>
      </DemographicsWrapper>
    );
  }
}

export default Habilidades;
